/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  let isRefreshing = false;
  // TODO: We need a nice alert or some area to display this information
  // Consult UX
  const updateAvailableNotification = worker => {
    if (confirm("Update available! Refresh browser now?")) {
      worker.postMessage({ action: "skipWaiting" })
    }
  }

  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registration() {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound(registration) {
      console.log('New content is downloading.')
    },
    updated (registration) {
      console.log('New content is available; please refresh.')
      updateAvailableNotification(registration.waiting)
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })

  // Listen to controllerchange to trigger reload
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (isRefreshing) {
        return
      }
      window.location.reload()
      isRefreshing = true
    })
  } else {
    console.log('Service workers are not supported. Some functionality may not work on your browser.')
  }
}
